import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import pic from '@/assets/test.png';
import { getSoureareaList, updateSourceAreaStatus, deleteSourceArea as _deleteSourceArea, addSourceArea, getSourceAreaDetail, updateSourceAreaInfo } from '@/services/product/sourcearea';
function getBase64(img, callback) {
  var reader = new FileReader();
  reader.addEventListener('load', function () {
    return callback(reader.result);
  });
  reader.readAsDataURL(img);
}
export default {
  name: 'sourcearea',
  components: {},
  i18n: require('./i18n-sourcearea'),
  data: function data() {
    var _this = this;
    /* 上传原产地图片验证 */
    var sourceAreaPicValidate = function sourceAreaPicValidate(rule, value, callback) {
      if (_this.modalValue.pictureUrl == null || _this.modalValue.pictureUrl == '') {
        callback(new Error(_this.$t('public.uploadPictureProp')));
      } else {
        callback();
      }
    };
    return {
      saveLoading: false,
      updateLoading: false,
      /* 系统设置中选择的语言 */
      langList: [],
      urlHost: '',
      action: '',
      updateData: {},
      //列表数据
      tableDataList: [],
      isTableLoading: false,
      loading: false,
      imageUrl: '',
      defaultLangObj: {},
      errTip: this.$t('sourcearea.input'),
      filter: {
        page: 1,
        each_num: 20,
        totalCount: 0 //总数据数量
      },
      dialogStatus: '',
      //新建/修改状态位
      textMap: {
        //新建/修改title
        update: this.$t('sourcearea.sourceareaEdit'),
        create: this.$t('sourcearea.sourceareaInsert')
      },
      visible: false,
      //新建/修改 显示
      initialNameList: [],
      modalValue: {
        id: '',
        pictureUrl: '',
        nameList: []
      },
      rules: {
        sourceAreaPic: [{
          required: true,
          validator: sourceAreaPicValidate,
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  created: function created() {
    this.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    this.updateData = {
      type: 4
    };
    this.getList();
    this.getInitialValue();
  },
  methods: {
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          //标题
          nameObj.titleName = self.$t('sourcearea.sourceareaName') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //规格值名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initialNameList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.modalValue.nameList = _.cloneDeep(self.initialNameList);
    },
    handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          var picurl = info.file.response.data.uploadfilepath;
          var urlpath = info.file.response.data.urlpath;
          this.modalValue.pictureUrl = picurl;
          this.imageUrl = urlpath + picurl;
          this.loading = false;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    /* 编辑按钮 */updata: function updata(record) {
      var _this2 = this;
      // this.modalValue.id = record.id
      getSourceAreaDetail(record.id).then(function (response) {
        if (response.data.code == 200) {
          var dataNameList = response.data.data.nameList;
          _this2.modalValue.id = response.data.data.id;
          _this2.modalValue.pictureUrl = response.data.data.pictureUrl;
          _this2.urlHost = response.data.data.urlHost;
          _this2.imageUrl = _this2.urlHost + _this2.modalValue.pictureUrl;
          var newNameList = _.cloneDeep(_this2.initialNameList);
          var _iterator2 = _createForOfIteratorHelper(newNameList),
            _step2;
          try {
            var _loop = function _loop() {
              var initial = _step2.value;
              var findObj = _.find(dataNameList, function (o) {
                return o.langId == initial.langId;
              });
              if (findObj) {
                initial.id = findObj.id;
                initial.name = findObj.name;
              }
            };
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this2.modalValue.nameList = _.cloneDeep(newNameList);
          _this2.dialogStatus = 'update';
          _this2.visible = true;
          _this2.updateLoading = false;
        }
      });
    },
    /* 添加按钮 */addModal: function addModal() {
      this.dialogStatus = 'create';
      this.resetmodalValue();
      this.loading = false;
      this.visible = true;
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetmodalValue();
    },
    resetmodalValue: function resetmodalValue() {
      this.modalValue = {
        id: "",
        pictureUrl: '',
        nameList: _.cloneDeep(this.initialNameList)
      };
      this.imageUrl = '';
      this.saveLoading = false;
    },
    /* 确定添加 */saveModal: function saveModal() {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.saveLoading = true;
          addSourceArea(_this3.modalValue).then(function (response) {
            if (response.data.code == 200) {
              _this3.$message.success(_this3.$t('sourcearea.insertOk'));
              _this3.visible = false;
              _this3.getList();
            } else {
              _this3.saveLoading = false;
            }
          }).finally(function () {
            _this3.saveLoading = false;
          });
        }
      });
    },
    /* 确定更新 */updateModal: function updateModal() {
      var _this4 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this4.updateLoading = true;
          updateSourceAreaInfo(_this4.modalValue).then(function (response) {
            if (response.data.code == 200) {
              _this4.$message.success(_this4.$t('sourcearea.updateOk'));
              _this4.visible = false;
              _this4.getList();
            } else {
              _this4.updateLoading = false;
            }
          }).finally(function () {
            _this4.updateLoading = false;
          });
        }
      });
    },
    /* 获取原产地数据 */getList: function getList() {
      var self = this;
      self.isTableLoading = true;
      getSoureareaList().then(function (response) {
        self.tableDataList = response.data.data.list;
        self.urlHost = response.data.data.urlHost;
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 删除原产地数据 */deleteSourceArea: function deleteSourceArea(id) {
      var _this5 = this;
      _deleteSourceArea(id).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success(_this5.$t('sourcearea.deleteOk'));
          _this5.getList();
        }
      });
    },
    /* 更新原产地状态 */updateStatus: function updateStatus(id, type, record) {
      var _this6 = this;
      var statusObj = {
        id: id,
        status: type
      };
      var key = "updateSourceAreaStatusLoading" + id + type;
      if (record[key]) return;
      record[key] = true;
      updateSourceAreaStatus(statusObj).then(function (response) {
        if (response.data.code == 200) {
          _this6.$message.success(_this6.$t('sourcearea.updateOk'));
          _this6.getList();
        }
      }).finally(function () {
        record[key] = false;
      });
    }
  }
};